<template>
  <draggable
    v-model="items"
    @start="drag = true"
    @end="drag = false"
    @change="change"
  >
    <transition-group>
      <component
        :is="componentName"
        v-for="item in items"
        :key="item.id"
        :value="item"
        @edit="
          (val) => {
            editDocumentBlock(val, item.order);
          }
        "
        @delete="$emit('delete', item.id)"
        @add="
          (val) => {
            addDocumentBlock(val, item.order);
          }
        "
        @apply="
          (versionId) => {
            $emit('apply', { versionId, id: item.id });
          }
        "
        @decline="
          (versionId) => {
            $emit('decline', { versionId, item });
          }
        "
      />
    </transition-group>
  </draggable>
</template>
<script>
import draggable from "vuedraggable";
import DocumentBlockViewer from "../views/document-blocks/DocumentBlockViewer.vue";

export default {
  components: {
    draggable,
    DocumentBlockViewer,
  },
  props: ["value", "componentName"],
  data: () => ({
    items: [],
  }),
  watch: {
    value: {
      handler(val) {
        this.items = [...new Set(val)];
        this.addOrders();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    addOrders() {
      this.items.forEach((i, index) => {
        i.order = index + 1;
      });
    },
    change() {
      this.addOrders();
      this.$emit("move", this.items);
    },
    addDocumentBlock(blockId, order) {
      this.$emit("add", { blockId, order });
    },
    editDocumentBlock(blockId, order) {
      this.$emit("edit", { blockId, order });
    },
  },
};
</script>

<style>
.layout {
  cursor: n-resize;
}
</style>